import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { BookOpen, Download } from "lucide-react";
import { fileUrl } from "@/lib/api";
import { PdfViewerModal } from "@/components/PdfViewerModal";

export const MagazineCard = ({ issue }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <div data-testid={`magazine-card-${issue.id}`} className="card-hover bg-white rounded-xl overflow-hidden border border-amber-200/60 shadow-sm flex flex-col">
        <div className="relative aspect-[3/4] bg-gradient-to-br from-amber-600 to-terracotta overflow-hidden" style={{ background: "linear-gradient(135deg,#d97706,#9a3412)" }}>
          {issue.cover_url ? (
            <img src={fileUrl(issue.cover_url)} alt={issue.title} className="w-full h-full object-cover" />
          ) : (
            <div className="w-full h-full flex flex-col items-center justify-center text-white p-4 text-center">
              <i className="fa-solid fa-newspaper text-4xl mb-3" />
              <span className="font-serif-deva text-lg">{issue.title}</span>
              {(issue.month || issue.year) && <span className="text-sm mt-1">{issue.month} {issue.year}</span>}
            </div>
          )}
          {issue.issue_number && (
            <span className="absolute top-3 left-3 bg-[#0a2540] text-white text-xs px-2.5 py-1 rounded-full">
              अंक {issue.issue_number}
            </span>
          )}
        </div>
        <div className="p-4 flex flex-col flex-1">
          <h3 className="font-serif-deva text-lg text-[#0a2540] leading-snug line-clamp-2">{issue.title}</h3>
          <p className="text-sm text-amber-700 mt-1">{[issue.month, issue.year].filter(Boolean).join(" ")}{issue.date && ` • ${issue.date}`}</p>
          {issue.description && <p className="text-sm text-slate-600 mt-2 line-clamp-2 flex-1">{issue.description}</p>}
          <div className="flex gap-2 mt-4">
            <Button size="sm" data-testid={`magazine-read-${issue.id}`} onClick={() => setOpen(true)} disabled={!issue.pdf_url}
              className="flex-1 bg-[#0a2540] hover:bg-[#061729] gap-1">
              <BookOpen size={15} /> पढ़ें
            </Button>
            <a href={fileUrl(issue.pdf_url, true)} target="_blank" rel="noopener noreferrer" className={`flex-1 ${!issue.pdf_url && "pointer-events-none opacity-50"}`} data-testid={`magazine-download-${issue.id}`}>
              <Button size="sm" variant="outline" className="w-full border-amber-400 text-amber-700 hover:bg-amber-50 gap-1">
                <Download size={15} /> डाउनलोड
              </Button>
            </a>
          </div>
        </div>
      </div>
      <PdfViewerModal open={open} onOpenChange={setOpen} url={issue.pdf_url} title={issue.title} />
    </>
  );
};
